const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/agentic-insights/experimental/classic.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { agenticInsightsBeforeLoad } from '../index';
const classicSearchSchema = z.object({
  // `.catch(undefined)` rather than a plain `.optional()`: an empty `?runId=` is still a present,
  // non-undefined string, so a bare `.optional()` would let it through as an "explicit selection" —
  // useSelectedRunId would then treat `''` as a real id and useViewedRun would fetch it.
  runId: z.string().min(1).optional().catch(undefined)
});

/**
 * Classic, frozen as it behaved before it was folded into the variant lineup. It fits neither the
 * `briefing` line nor the `intelligence` line, so it carries its own `classic` line in
 * `VariantPicker.tsx` rather than a briefing/intelligence number it was never part of.
 */
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/agentic-insights/experimental/classic')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: agenticInsightsBeforeLoad,
  validateSearch: search => classicSearchSchema.parse(search),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.agenticInsights.title)
    }
  }
});